import { safeCombineEpics } from '@cbridge-utils/redux-observable';
import { loadPricingRuleEpic } from './_epics/loadPricingRule.epic';
import { updatePricingRuleEpic } from './_epics/updatePricingRule.epic';
import { validatePricingRuleEpic } from './_epics/validatePricingRule.epic';
import { exportPricingRulesEpic } from './_epics/exportPricingRules.epic';
import { reloadPricingRuleListEpic } from './_epics/reloadPricingRule.epic';

export const pricingRuleEpic = safeCombineEpics(
  loadPricingRuleEpic,
  updatePricingRuleEpic,
  validatePricingRuleEpic,
  exportPricingRulesEpic,
  reloadPricingRuleListEpic,
);
